'use client';
import { useMemo } from 'react';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { appTheme } from '@/styles/theme';
// import { lightColors, darkColors } from "@/styles/theme/colors";
import { lightColors } from '@/styles/theme/colors';
import { iranSans } from '@/styles/theme/typography';

const MuiProvider = ({ children }) => {
  const themeMode = 'light';
  const muiTheme = useMemo(
    () =>
      createTheme({
        direction: 'rtl',
        palette: {
          mode: themeMode,
          ...lightColors,
        },
        ...appTheme,
      }),
    [themeMode],
  );
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <div className={iranSans.className}> {children}</div>
    </ThemeProvider>
  );
};

export default MuiProvider;
